<template>
  <v-container fluid grid-list-md>
    <v-layout column align-center justify-center>
      <v-flex d-flex class="action-text">{{messages.cancelAppointmentConfirmationText}}</v-flex>
      <v-flex d-block class="action-button">
        <v-btn
          :ripple="false"
          class="submit edit"
          flat
          @click="cancelAppointment"
          id="cancelButton"
        >{{messages.cancelAppointmentConfirmButtonText}}</v-btn>
      </v-flex>
      <v-flex d-block class="action-button">
        <v-btn
          :ripple="false"
          class="submit cancel"
          flat
          @click="goBackToAppointment"
          id="backToAppointmentButton"
        >{{messages.cancelAppointmentAbortButtonText}}</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import RestService from '../services/restService'
import { mapState } from 'vuex'

export default {
  name: 'CancelAppointment',
  props: [
    'appointment'
  ],
  computed: {
    ...mapState([
      'messages'
    ])
  },
  mixins: [RestService],
  methods: {
    goBackToAppointment () {
      this.$router.go(-1)
    },
    cancelAppointment () {
      var _this = this
      this.deleteAppointment(this.appointment.publicId).then(response => {
        _this.$emit('deleted-appointment', true)
      })
    }
  },
  mounted () {
    var _this = this
    if (!this.appointment) {
      _this.$router.push({
        name: 'appointment',
        params: {
          appointmentId: _this.$route.params.appointmentId
        }
      })
    }
  }
}
</script>

<style>
</style>
